import Vue from 'vue'
import Vuex from 'vuex'
import history from './modules/history'
import profile from './modules/profile'
import payment from './modules/payment'
import fetchRecipts from './modules/recipts'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default (recipts, workouts, isMH, requireSaleId, apiPrefix, host, isWomanPortal) => new Vuex.Store({
  modules: {
    global: { getters: { isMH: () => isMH, requireSaleId: () => requireSaleId, apiPrefix: () => apiPrefix, host: () => host, isWomanPortal: () => isWomanPortal === undefined ? false : isWomanPortal } },
    history,
    payment,
    profile,
    recipts: fetchRecipts(recipts),
    workouts
  },
  strict: debug,
})


// WEBPACK FOOTER //
// ./src/store/fitnes/index.js